import { Aggregate, APIFieldType, WidgetTypes } from '@ardoq/api-types';
import { widgetOperations } from '@ardoq/dashboard';
import { aggregates, aggregatesWithLabel } from '@ardoq/report-reader';
import { isUndefined } from 'lodash';

export const WIDGETS_TYPES_THAT_WORK_WITH_COUNT_AGGREGATE = new Set([
  WidgetTypes.LINE_CHART,
  WidgetTypes.NUMBER,
  WidgetTypes.TABLE,
]);

type AggregateValidationAttributes = {
  aggregate: Aggregate;
  fieldTypes: APIFieldType[];
  widgetType?: WidgetTypes;
};

const isValidAggregate = ({
  aggregate,
  fieldTypes,
  widgetType,
}: AggregateValidationAttributes) => {
  if (isUndefined(widgetType)) return false;
  if (widgetOperations.isCategoricalChartType(widgetType)) {
    // 1 or 2 fields; if 1 and it's Number then another needs to be added and we are doing sum
    if (fieldTypes.length === 1) {
      const [fieldOneType] = fieldTypes;
      if (fieldOneType === APIFieldType.NUMBER) {
        return aggregate === Aggregate.SUM;
      }
      return aggregate === Aggregate.COUNT;
    }
    if (fieldTypes.length === 2) {
      // Currently, we only want to support SUM for 2-field aggregation:
      return aggregate === Aggregate.SUM;
    }
  }
  if (aggregate === Aggregate.COUNT) {
    return WIDGETS_TYPES_THAT_WORK_WITH_COUNT_AGGREGATE.has(widgetType);
  }
  if (widgetType === WidgetTypes.LINE_CHART) {
    return fieldTypes.every(item => item === APIFieldType.NUMBER);
  }
  return (
    (widgetType === WidgetTypes.NUMBER || widgetType === WidgetTypes.TABLE) &&
    fieldTypes.includes(APIFieldType.NUMBER)
  );
};

export const getValidAggregates = (args: {
  fieldTypes: APIFieldType[];
  widgetType?: WidgetTypes;
}) => aggregates.filter(aggregate => isValidAggregate({ ...args, aggregate }));

export const getIsAggregateDisabledAndPopoverContent = ({
  aggregate,
  fieldTypes,
  widgetType,
}: AggregateValidationAttributes) =>
  isValidAggregate({ aggregate, fieldTypes, widgetType })
    ? { isDisabled: false }
    : {
        isDisabled: true,
        popoverContent: `${aggregatesWithLabel[aggregate]} ${
          !(
            widgetType &&
            WIDGETS_TYPES_THAT_WORK_WITH_COUNT_AGGREGATE.has(widgetType)
          )
            ? 'aggregate can only be used with number, table and line charts.'
            : 'aggregate can only be used with number fields.'
        }`,
      };
